/* eslint-disable no-restricted-globals */

import { SearchTGSynonyms, XPathSynonyms } from "../features/search/search.util";

self.onmessage = function (e) {
  const { searchableValues, searchInputValue, tgg } = e.data;
  const max_search_terms = 40;

  let synIndex = SearchTGSynonyms(searchInputValue, tgg);
  let synArray;
  if (synIndex && synIndex.length > 0) {
    synArray = tgg.synonyms.rows[synIndex[0]][0].split(',').map(keyword => keyword.trim().toLowerCase());
    self.postMessage({ results: synArray });
    return;
  }

  try {

    if (!searchInputValue) {
      self.postMessage({ results: [] });
      return;
    }

    const searchTermLower = searchInputValue.toLowerCase();
    const results = new Set();

    for (const [term, termLower] of searchableValues) {
      if (results.size >= max_search_terms) break;

      if (termLower.includes(searchTermLower)) {
        results.add(term);
      }
    }

    // Sort results
    const sortedResults = Array.from(results).sort((a, b) => {
      const aLower = a.toLowerCase();
      const bLower = b.toLowerCase();
      const aIndex = aLower.indexOf(searchTermLower);
      const bIndex = bLower.indexOf(searchTermLower);

      // Prioritize exact matches
      const aExact = aLower === searchTermLower;
      const bExact = bLower === searchTermLower;
      if (aExact && !bExact) return -1;
      if (!aExact && bExact) return 1;

      if (aIndex === bIndex) return a.localeCompare(b);
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      return aIndex - bIndex;
    });

    self.postMessage({ results: sortedResults });
  } catch (error) {
    self.postMessage({ error: error.message });
  }
};